import { toBoolean } from '@local_modules/flokit'

/**
 * Update :forFeaturePublicAccount
 * @param {String} htmlContent
 * @returns {String} updated HTML string
 */
export function applyPublicAccountFeatureClass (htmlContent) {
  const toggleUserClientPosition = localStorage.getItem('featurePublicAccounts')
  if (toBoolean(toggleUserClientPosition) === true) {
    htmlContent = htmlContent.replaceAll(':forFeaturePublicAccount', '')
  } else {
    htmlContent = htmlContent.replaceAll(':forFeaturePublicAccount', 'is-hidden')
  }
  return htmlContent
}
